import { common } from "./ru/common";
import { auth } from "./ru/auth";
import { onboarding } from "./ru/onboarding";
import { profile } from "./ru/profile";
import { settings } from "./ru/settings";
import { matching } from "./ru/matching";
import { chat } from "./ru/chat";
import { company } from "./ru/company";
import { events } from "./ru/events";
import { checkin } from "./ru/checkin";
import { miniApps } from "./ru/mini-apps";
import { card } from "./ru/card";
import { connect } from "./ru/connect";
import { points } from "./ru/points";
import { demo } from "./ru/demo";
import { native } from "./ru/native";
import { landing } from "./ru/landing";
import { tags } from "./ru/tags";
import { postMeetup } from "./ru/post-meetup";

export const ru = {
  ...common,
  ...auth,
  ...onboarding,
  ...profile,
  ...settings,
  ...matching,
  ...chat,
  ...company,
  ...events,
  ...checkin,
  ...miniApps,
  ...card,
  ...connect,
  ...points,
  ...demo,
  ...native,
  ...landing,
  ...tags,
  ...postMeetup,
};
